import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalDataBusService {
  public MemberChanged: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public static FacilityChanged: BehaviorSubject<boolean> = new BehaviorSubject(
    true
  );
  public static patientIdLoaded: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public static IsConfidentialLoggedIn: boolean = false;
  public static ConfPassword: string = "";
  public static bacicTheme: { Key: string; Value: string }[] = [];
  public static appName: string = "QDHealth Appoitment System";
  public static appLogo: string;
  public static appLogoProfile: string;
  public static appSettings: any;
  public static AuthorizationToken: string = "";
  public PrefferedHospital: BehaviorSubject<string> = new BehaviorSubject("");
  public static Facility_ID: number = 0;
  public static Cur_Symbol: string = 'OMR'
  public static AdminLogged: boolean = false;
  public static facilityIdBefore: string = "";
  public static objFacilityID: any = {};
  public static glProfileCountry: any = undefined;
  public static userMenu: any[] = [];
  public static clientSettings :any={}
  public static isMenuExpanded : boolean = true
  public static PrefferdLanguages: any[] = [
    { Code: "en", Name: "English" },
    { Code: "ar", Name: "عربى" },
  ];
  public static MemberChangedFromOutSide: BehaviorSubject<
    boolean
  > = new BehaviorSubject(false);
  public static loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public static currMembId : number = -1
  constructor() {}
  public static Notifications: {
    Key: string;
    Description: string;
    dTime: Date;
  }[] = [];
  public static appIPAddress: string = "";
  public static appCountryCode: string = "";

  public static get defaultFacility(): { "Facility_Id": number,"Facility_Name":string}{
    return JSON.parse(localStorage.getItem("DefaultFacility"))
  }
  public static loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public static loadingMap: Map<string, boolean> = new Map<string, boolean>();
  public static isDashBoard : boolean = false
  GetConfidentialData() {}
}

